import script from "./ProductDetailVisualization.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductDetailVisualization.vue?vue&type=script&lang=ts&setup=true"

import "./ProductDetailVisualization.vue?vue&type=style&index=0&id=5fa28fa8&scoped=true&lang=less"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa28fa8"]])

export default __exports__